// extracted by mini-css-extract-plugin
module.exports = {"clickableBox":"Topbar_clickableBox__3N3jX"};